/* eslint-disable react/jsx-props-no-spreading */
import { useMemo } from "react";

import { Typography } from "components";
import { dayjsFormatTZ, dayjsTZ } from "helpers";

interface TimeFormatProps {
  time?: string;
  format?:
    | "MM/YYYY"
    | "HH:mm"
    | "HH:mm:ss"
    | "DD/MM/YYYY"
    | "DD-MM-YYYY"
    | "DD/MM/YYYY HH:mm"
    | "DD-MM-YYYY HH:mm"
    | "DD/MM/YYYY HH:mm:ss"
    | "DD-MM-YYYY HH:mm:ss"
    | "HH:mm DD/MM/YYYY";
  initFormat?: "YYYY-MM-DD";
  typographyProps?: Partial<React.ComponentProps<typeof Typography>>;
}

const TimeFormat: React.FC<TimeFormatProps> = ({
  time,
  format = "DD/MM/YYYY",
  initFormat,
  typographyProps,
}) => {
  const timeFormat = useMemo(() => {
    if (initFormat && time) {
      return dayjsFormatTZ(String(time), initFormat).format(format);
    }
    return time ? dayjsTZ(String(time)).format(format) : "";
  }, [format, initFormat, time]);

  return <Typography {...typographyProps}>{timeFormat}</Typography>;
};

export default TimeFormat;
